module.exports = "## Subheader\n\n[Subheaders](https://www.google.com/design/spec/components/subheaders.html)\nare special list tiles that delineate distinct sections of a list or\ngrid list and are typically related to the current filtering or sorting criteria.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Subheader/README.md
 ** module id = 1065
 ** module chunks = 0
 **/